/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from 'components/CustomComponents';
import { ATCONSTANTS as ATC } from 'appconstants';
import bindLogger from 'helpers/BindLogger';
import { withAppContext } from '@ctsu/loader';
import { getNextPacketId } from 'actions/packet';
import {
  CanSeeMyLocks,
  CanSeeMyPackets,
  CanSeeNextPacket,
  CanSeeIndexing,
  CanSeeTon,
  CanSeeEntry
} from 'appconstants/Permission';
import { showErrorNotification } from 'helpers';

function FnBtnField(props) {
  const {
    name, permission, onClick, title, id, noPipe
  } = props;
  return permission() ? (
    <>
      <a
        href="#"
        className="lnk"
        data-id={`${ATC.PACKETID}${name.split(' ').join('_').toUpperCase()}${ATC.BUTTON}`}
        onClick={onClick}
        title={title}
        id={id}
      >
        {name}
      </a>
      {noPipe === true ? '' : <span className="color-turquoise mx-1">|</span>}
    </>
  ) : null;
}

function ButtonField(props) {
  const { name, permission } = props;
  return permission() ? (
    <Button
      data-id={`${ATC.PACKETID}${name.split(' ').join('_').toUpperCase()}${ATC.BUTTON}`}
      className="btn turquoise mx-1"
      {...props}
    />
  ) : null;
}

function ExternalFilter(props) {
  const {
    appliedFilters, controller, context, setAppliedfilters, setSelectedOptions, setSearchData, onSearch, nextPacketIdAc
  } = props;
  const { session } = context;
  const isDisabledNxtPkt = !appliedFilters.assignedTo;

  const clearPacketFilter = () => {
    setSelectedOptions([]);
    setSearchData({});
    onSearch(null);
  };

  const removeClass = () => {
    const menuArr = ['viewAllTON', 'entry', 'viewMyPkts', 'indexing', 'viewMyLocks'];
    let cls;
    menuArr.forEach(item => {
      if (document.getElementById(item)) {
        cls = document.getElementById(item).classList;
        cls.remove('font-bold');
      }
    });
  };

  const filterHandler = (filter) => {
    clearPacketFilter();
    let newFilter = {};
    let cls;
    controller.filterExternally({}, false, true);

    switch (filter) {
      case 'viewAllTON':
        newFilter = {
          status: 'NOT COMPLETE',
          assignedTo: 'AQ_TON'
        };
        cls = document.getElementById('viewAllTON').classList;
        removeClass();
        cls.add('font-bold');
        break;
      case 'entry':
        newFilter = {
          status: 'QUEUED',
          assignedTo: 'AQ_NEW'
        };
        cls = document.getElementById('entry').classList;
        removeClass();
        cls.add('font-bold');
        break;
      case 'viewMyPkts':
        newFilter = {
          assignedTo: session.username,
          status: 'WORKING'
        };
        cls = document.getElementById('viewMyPkts').classList;
        removeClass();
        cls.add('font-bold');
        break;
      case 'indexing':
        newFilter = {
          status: 'RELEASED',
          assignedTo: 'AQ_NEW'
        };
        cls = document.getElementById('indexing').classList;
        removeClass();
        cls.add('font-bold');
        break;
      case 'viewMyLocks':
        newFilter = {
          lockedBy: session.username
        };
        cls = document.getElementById('viewMyLocks').classList;
        removeClass();
        cls.add('font-bold');
        break;
      default:
    }
    controller.filterExternally(newFilter, false, true);
    controller.applyFilter();
    setAppliedfilters(newFilter);
  };

  const handleNextPacket = () => {
    clearPacketFilter();
    bindLogger(nextPacketIdAc, context)(
      appliedFilters.object ? appliedFilters.object : 'all',
      appliedFilters.assignedTo
    ).subscribe(
      (resp) => {
        if (resp.length === 0) {
          showErrorNotification('No unassigned packets available or you are not authorized to process packets.');
        } else {
          const newFilter = {
            packetId: resp
          };
          controller.filterExternally(newFilter, true, false);
          setAppliedfilters(newFilter);
        }
      },
      (error) => {
        const errorLog = JSON.parse(error.response);
        showErrorNotification(errorLog.error);
      }
    );
  };

  return (
    <div>
      <span className="color-dark-blue mr-1">Preset Filters:</span>
      <FnBtnField
        name="All TON"
        onClick={() => {
          filterHandler('viewAllTON');
        }}
        title="All Time of Need (TON) Packets"
        permission={CanSeeTon}
        id="viewAllTON"
      />
      <FnBtnField
        name="Indexing"
        onClick={() => {
          filterHandler('indexing');
        }}
        title="View only packets in AQ_New and Released"
        permission={CanSeeIndexing}
        id="indexing"
      />
      <FnBtnField
        name="Entry"
        onClick={() => {
          filterHandler('entry');
        }}
        title="View only packets in AQ_New and Queued"
        permission={CanSeeEntry}
        id="entry"
      />
      <FnBtnField
        name="My Locks"
        onClick={() => {
          filterHandler('viewMyLocks');
        }}
        title="My Locks"
        permission={CanSeeMyLocks}
        id="viewMyLocks"
      />
      <FnBtnField
        name="My Pkts"
        onClick={() => {
          filterHandler('viewMyPkts');
        }}
        title="My Pkts"
        permission={CanSeeMyPackets}
        id="viewMyPkts"
        noPipe
      />
      <ButtonField
        name="Next Pkt"
        isDisabled={isDisabledNxtPkt}
        onClick={handleNextPacket}
        title="Next Packet"
        permission={CanSeeNextPacket}
        className="btn turquoise ml-2 mr-1"
      />
    </div>
  );
}

const withConnectState = connect(null, (dispatch) => bindActionCreators(
  {
    nextPacketIdAc: getNextPacketId
  },
  dispatch
));

export default withAppContext(withConnectState(ExternalFilter));
